import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'userFilter'})
export class UserFilter implements PipeTransform {
    transform(array: any[], active: boolean ): any[] {
        if (array) {
            return array.filter(user => {
                return !active || user.active || false;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/users/users.filter.ts